module.exports = __webpack_public_path__ + "img/r-d.4b70ebfb.png";